(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cgm_morgana_assistant"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cgm-morgana-guide')) {
customElements.define('cgm-morgana-guide', class extends HTMLElement {
connectedCallback() {
if (this.bound) return;
this.bound = true;
this.events = new AbortController();
this.panel = this.querySelector('dialog');
this.launcher = this.querySelector('[data-open]');
if (!this.panel || !this.launcher) return;
this.launcher.hidden = false;
this.topic = '';
this.interest = '';
this.refreshLink();
this.addEventListener('click', (event) => {
if (!(event.target instanceof Element)) return;
const button = event.target.closest('button');
if (!button || !this.contains(button)) return;
if (button.hasAttribute('data-open')) {
this.previousFocus = document.activeElement;
this.panel.showModal();
this.launcher.setAttribute('aria-expanded', 'true');
} else if (button.hasAttribute('data-close')) {
this.panel.close();
} else if (button.hasAttribute('data-topic')) {
this.topic = button.dataset.label || '';
this.interest = '';
this.showView(button.dataset.topic);
} else if (button.hasAttribute('data-back')) {
this.topic = '';
this.interest = '';
this.showView('home');
} else if (button.hasAttribute('data-interest')) {
this.interest = button.dataset.interest || '';
this.querySelectorAll('[data-interest]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
this.refreshLink();
}
}, { signal: this.events.signal });
this.panel.addEventListener('close', () => {
this.launcher.setAttribute('aria-expanded', 'false');
this.previousFocus?.focus?.({ preventScroll: true });
}, { signal: this.events.signal });
}
showView(name) {
const target = [...this.querySelectorAll('[data-view]')].find((view) => view.dataset.view === name);
if (!target) return;
this.querySelectorAll('[data-view]').forEach((view) => { view.hidden = view !== target; });
this.querySelectorAll('[data-interest]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
this.refreshLink();
target.querySelector('h3')?.focus({ preventScroll: true });
this.querySelector('.cgm-morgana__body').scrollTop = 0;
}
refreshLink() {
const subject = [this.topic, this.interest].filter(Boolean).join(' - ');
const phone = (this.dataset.phone || '').replace(/[^0-9]/g, '');
const link = this.querySelector('[data-whatsapp]');
if (phone.length >= 8 && phone.length <= 15) {
link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent((this.dataset.prefix || '') + (subject || this.dataset.default || ''));
link.hidden = false;
} else { link.hidden = true; }
this.querySelector('[data-selection]').hidden = !subject;
this.querySelector('[data-selection-text]').textContent = subject;
}
disconnectedCallback() {
this.events?.abort();
if (this.panel?.open) this.panel.close();
this.bound = false;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
